import React, { useState } from "react";
import { AgChartsReact } from "ag-charts-react";

function getData() {
  return [
    {
      type: 'SHR',
      open: 1013,
      complete: 822,
      inProgress: 168,
    },
    {
      type: 'MOU',
      open: 2842,
      complete: 938,
      inProgress: 231,
    },
    {
      type: 'RET',
      open: 4567,
      complete: 773,
      inProgress: 274,
    },
    {
      type: 'PRJ',
      open: 3655,
      complete: 294,
      inProgress: 4,
    },
    {
      type: 'MISC',
      open: 1486,
      complete: 214,
      inProgress: 180,
    },
  ];
}

function getTotal(datum) {
  return (
    datum.open +
    datum.complete +
    datum.inProgress
  );
}

const data = getData();
const numFormatter = new Intl.NumberFormat('en-US');
const total = data.reduce((sum, d) => sum + d['count'], 0);

export default function ChartRequestType() {
  const [options, setOptions] = useState({
    autoSize: true,
    data: getData().sort(function (a, b) {
      return getTotal(b) - getTotal(a);
    }),
    theme: {
      baseTheme: "ag-default-dark",
      overrides: {
        bar: {
          series: {
            strokeWidth: 0,
            highlightStyle: {
              series: {
                strokeWidth: 1,
                dimOpacity: 0.3,
              },
            },
          },
        },
      },
    },
    title: {
      text: 'Request by Issue Type and Status',
      fontSize: 18,
      spacing: 25,
    },
    series: [
      {
        type: 'bar',
        xKey: 'type',
        yKey: 'open',
        yName: 'Open',
        stacked: true,
      },
      {
        type: 'bar',
        xKey: 'type',
        yKey: 'complete',
        yName: 'Complete',
        stacked: true,
      },
      {
        type: 'bar',
        xKey: 'type',
        yKey: 'inProgress',
        yName: 'In Progress',
        stacked: true,
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'left',
      },
      {
        type: 'number',
        position: 'top',
        nice: false,
      },
    ],
    legend: {
      position: "top",
    },
  });

  return <AgChartsReact options={options} />;
}
